<script setup>
defineProps({
  presets: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-xs font-medium text-n-slate-11">
      {{ $t('FILTER.PRESETS.TITLE') }}
    </span>
    <div class="flex flex-wrap gap-2">
      <button
        v-for="preset in presets"
        :key="preset.key"
        type="button"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm transition-colors border rounded-full bg-n-alpha-2 border-n-weak text-n-slate-12 hover:bg-n-alpha-3"
        @click="emit('select', preset)"
      >
        <span :class="preset.icon" class="size-4 text-n-slate-11" />
        {{ preset.label }}
      </button>
    </div>
  </div>
</template>
